//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VueClazyLoad } from 'vue-clazy-load'

export default {
  components: {
    VueClazyLoad
  },
  nuxtI18n: {
    paths: {
      es: '/promociones'
    }
  },
  data() {
    return {
      promotions: [],
      parent_slug: 'regular',
      selected_promotion: null,
      clubBetPageId: null,
      openModal: false,
      modalMessage: `
      <h3 class="font-bold mb-2">Esta promoción es solo para miembros de CLUB BET777.</h3>
      <p class="text-sm mb-2"><span class="text-primary font-bold">Acumula puntos</span> con esas apuestas en las que no has tenido suerte.</p>
      <p class="text-sm">Recibe <span class="text-primary font-bold">PROMOCIONES EXCLUSIVAS</span> en los eventos más atractivos formando parte del CLUB.</p>
      `,
      modalTitle: '¡Disculpa!',
      modalAction: 'optin-to-club-bet',
      modalTitleColor: 'text-primary',
      showModalButton: true,
      buttonActionText: 'UNIRME AL CLUB',
      topImage: '',
      termsHtml: ' ',


    }
  },
  computed: {
    isLoggedIn() {
      return this.user
    },
  },
  watch: {
    isLoggedIn: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.fetchPromotions();
        }
      }
    }
  },
  async fetch() {
    await this.fetchPromotions()
  },
  fetchOnServer: false,
  methods: {
    handleClose() {
      this.openModal = false;
    },
    handlePopupAction(action) {
      this.openModal = false;
      if (action === "optin-to-club-bet") {
        this.optinClub()
      }
    },
    async optinClub() {
      if (!this.user || this.clubBetPageId === null) {
        return
      }
      try {
        const CMS_OPT_IN_ENDPOINT = '/api/cms/content/opt-in';
        const response = await this.$new_cms().post(CMS_OPT_IN_ENDPOINT, {page_id: this.clubBetPageId});
        const isSuccess = Boolean(response?.data?.additional?.result);
        const messageKey = response?.data?.message ?? 'Unexpected error';

        if (!isSuccess) {
          this.$modal.show('modal-generic', {
            title: this.$t('Sorry!'),
            content: this.$t(messageKey),
          });
          return;
        }

        this.$store.commit('auth/storeUser', { is_club_bet_member: true });

        const currentList = (this.user && Array.isArray(this.user.opted_in_promotions))
            ? [...this.user.opted_in_promotions]
            : [];

        const alreadyOptedIn = currentList.some(p => p && p.page_id === this.clubBetPageId);

        if (!alreadyOptedIn) {
          currentList.push({ page_id: this.clubBetPageId });
          this.$store.commit('auth/storeUser', { opted_in_promotions: currentList });
        }

        this.$router.push(this.localePath({path: '/promociones/club-bet-777/actividad'}))

      } catch (err) {
        this.$modal.show('modal-generic', {
          title: this.$t('Sorry!'),
          content: this.$t('Unexpected error'),
        });
      }
    },
    openPromotion(promotion) {
      if (this.user) {

        this.selected_promotion = promotion
        if (promotion?.promotion?.under_club && !this.user.is_club_bet_member) {
          this.openModal = true
          this.topImage = promotion?.promotion?.media?.banner_popup
          return
        }

        const alreadyOptedIn = this.user.opted_in_promotions.some(p => p && p.page_id === promotion.id);

        if (alreadyOptedIn) {
          if (promotion?.promotion?.type === 'mission') {
            this.$router.push({
              path: '/promotion-missions/',
              query: { promotionId: promotion.promotion.id, pageId: promotion.id }
            })
            return
          }
          if (promotion?.promotion?.type === 'mission_bingol') {
            this.$router.push({
              path: '/promotion-bingol/',
              query: { promotionId: promotion.promotion.id, pageId: promotion.id }
            })
            return

          }
          if (promotion?.promotion?.type === 'mundial') {
            this.$router.push({
              path: '/promotion-mundial/',
              query: { promotionId: promotion.promotion.id, pageId: promotion.id }
            })
            return
          }
          if (promotion?.promotion?.type === 'tournament') {
            this.$router.push({
              path: '/promotion-tournament/',
              query: { promotionId: promotion.promotion.id, pageId: promotion.id }
            })
            return
          }
        }

      }

      const slug = String(promotion.url || '').replace(/^\/|\/$/g, '')
      const base = this.$route.path.replace(/\/$/, '')
      this.$router.push({ path: `${base}/${slug}/` })
    },

    getImgPath(promotion) {
      return promotion?.banner_media_url || null;
    },

    async fetchPromotions() {
      const PROMOTIONS_API = "api/cms/promotions";
      const INFO_PROMOS_API = `/api/cms/content?url=${this.parent_slug}`;
      const COMBO_BOOST_API = "/api/cms/content?url=combo-boost";

      const results = await Promise.allSettled([
        this.$new_cms().get(PROMOTIONS_API),
        this.$new_cms().get(INFO_PROMOS_API),
        this.$new_cms().get(COMBO_BOOST_API),
      ]);

      const getFulfilledData = (result, path = 'data.data') => {
        if (result?.status !== 'fulfilled') return null;
        return path.split('.').reduce((obj, key) => obj?.[key], result.value) || null;
      };

      const toPromoArray = (input) => {
        if (!input) return [];
        if (Array.isArray(input)) return input;
        if (typeof input === 'object') {
          const isSinglePromo = 'id' in input || 'promotion_type' in input || 'title' in input;
          return isSinglePromo ? [input] : Object.values(input).filter(v => v && typeof v === 'object');
        }
        return [];
      };

      const rawNewPromos = getFulfilledData(results[0]) || [];
      const rawInfoPromos = getFulfilledData(results[1], 'data.additional.children') || [];
      const rawComboBoost = getFulfilledData(results[2]) || {};

      const promoMap = {};

      // 1. Process Combo Boost
      if (rawComboBoost.id) {
        promoMap[rawComboBoost.id] = {...rawComboBoost, parent_slug: '', position: 0};
      }

      // 2. Process Info Promos (High priority/no opt-in)
      rawInfoPromos.forEach((promo) => {
        if (promo?.id) {
          promoMap[promo.id] = {...promo, parent_slug: this.parent_slug};
        }
      });

      // 3. Process Normal Promos (Don't overwrite existing ones)
      toPromoArray(rawNewPromos).forEach((promo) => {
        if (promo?.id && !promoMap[promo.id]) {
          promoMap[promo.id] = promo;
        }
      });

      // Convert to array and sort by position
      this.promotions = Object.values(promoMap).sort((a, b) => {
        const posA = a.position ?? Number.MAX_SAFE_INTEGER;
        const posB = b.position ?? Number.MAX_SAFE_INTEGER;
        return posA - posB;
      });

      if (this.clubBetPageId === null) {
        const item = this.promotions.find(p => p.url === "club-bet-777");
        this.clubBetPageId = item?.id ?? null;
        this.termsHtml = item?.promotion?.page?.terms_and_conditions_content ?? ' '
      }

    },

    async modalClosed() {
      await this.fetchPromotions()
    }
  }
}
